module.exports = __webpack_public_path__ + "assets/img/BF.75f3457e.png";